import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Formata uma data para 'dd/MM/yyyy' ou 'dd/MM/yyyy HH:mm', usando ptBR.
 * @param date - Data a ser formatada (Date ou string ou number)
 * @param withTime - Se true, inclui horas e minutos
 * @returns string formatada ou '-' se inválida
 */
export function formatDate(date: Date | string | number, withTime = false): string {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  return format(d, withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy', { locale: ptBR });
} 